import React, {useEffect, useMemo, useState} from "react";
import {shallowEqual, useDispatch, useSelector} from "react-redux";

import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
    ModalProgressBar,
} from "../../../../../../_metronic/_partials/controls";
import {AttachmentList} from "../../../../../../_metronic/_partials/attachments/AttachmentList";
import {fetchInvestigation} from "../../../_redux/investigations/investigationsActions";
import DOMPurify from "dompurify";
import {HasWriteAccess, IsSuperUser} from "../../../../../../_metronic/_helpers/AccessControlHelpers";
import {INVESTIGATION_MODEL} from "../../../../../../_metronic/_helpers/AppModels";

export function InvestigationSingle({
                                        history,
                                        match: {
                                            params: {id},
                                        },
                                    }) {
    const [title, setTitle] = useState("");
    const dispatch = useDispatch();

    const {actionsLoading, investigationToView, user} = useSelector(
        (state) => ({
            actionsLoading: state.investigations.actionsLoading,
            investigationToView: state.investigations.investigationToView,
            user: state.auth.user
        }),
        shallowEqual
    );

    useEffect(() => {
        if (dispatch && id) dispatch(fetchInvestigation(id));
    }, [id, dispatch]);

    useEffect(() => {
        if (investigationToView)
            setTitle(`بازرسی شعبه ${investigationToView.branchName}`);
    }, [investigationToView]);

    const sanitizedDescription = useMemo(() => {
        return DOMPurify.sanitize(investigationToView?.description || "");
    }, [investigationToView]);

    return (
        <Card>
            {actionsLoading && <ModalProgressBar/>}
            <CardHeader
                title={title}
                dateTime={new Date(investigationToView?.createDate).toLocaleString(
                    "fa-IR"
                )}
            >
                <CardHeaderToolbar>
                    <button
                        type={"button"}
                        className={"btn mr-4"}
                        style={{cursor: "default"}}
                    >
                        <i className={"fa fa-eye"}/>
                        <span className={"font-size-h3"} style={{color: "#6b6b6b"}}>
              {investigationToView?.viewCount}
            </span>
                    </button>


                    {(HasWriteAccess(user,  INVESTIGATION_MODEL) || IsSuperUser(user)) && (
                    
                    <button
                        type={"button"}
                        onClick={() => history.push(`/qc/investigations/${id}/edit`)}
                        className={"btn btn-primary mr-4"}
                    >
                        <i className={"fa fa-edit"}/>
                        ویرایش
                    </button>
                    )}

                    <button
                        type={"button"}
                        onClick={() => history.push("/qc/investigations")}
                        className={"btn btn-light"}
                    >
                        <i className={"fa fa-arrow-left"}/>
                        برگشت
                    </button>
                </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
                <div className={"mb-5"}>
                    <div className={"d-flex flex-column mb-8"}>
                        <div>
                            <p className={"font-size-h6 mb-1 font-weight-bolder"}>
                                توضیحات بازرسی:
                            </p>
                            <div
                                className="ml-4"
                                dangerouslySetInnerHTML={{__html: sanitizedDescription}}
                            />
                        </div>
                    </div>
                </div>
                <hr/>
                <h4 className={"mb-6"}>پیوست ها:</h4>
                {investigationToView && !actionsLoading && (
                    <AttachmentList
                        model={"Investigation"}
                        recordId={investigationToView.id}
                    />
                )}
            </CardBody>
        </Card>
    );
}
